<onyx-section [heading]="`${I18N}.heading`">
  <form [formGroup]="form()">
    <onyx-phone-number-input
      [formControl]="form().controls.phone"
      label="labels.storagePhone"
      [size]="32"
    ></onyx-phone-number-input>
  </form>
</onyx-section>
